<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889">
            <v-card flat color="#004889">
                <v-card-text class="pa-0">
                    <v-list flat color="#004889" class="py-0">
                        <v-list-item class="form-row">
                            <v-list-item-content class="label">
                                <v-list-item-title class="white--text font-weight-bold">Notifications</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="justify-end">
                                <v-btn
                                    large min-width="49%" color="accent" tile
                                    @click="notificationDialog = !notificationDialog"
                                >
                                    Manage
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card-text> 
            </v-card>
        </v-card>
        <Notifications :dialog="notificationDialog" @update-dialog="updateNotification"/>
    </v-container>
</template>

<script>
    import Notifications from '../../components/Notifications.vue'

    export default {
        data () {
            return {
                pageTitle: '',
                notificationDialog: false
            }
        },
        created() {
            this.pageTitle = this.$route.meta.title
        },
        components: {
            Notifications
        },
        methods: {
            updateMediaDialog(val) {
                this.mediaDialog = val
            },
            updateChatDialog(val) {
                this.chatDialog = val
            },
            updateJobDialog(val) {
                this.jobDialog = val
            },
            updateNotification(val) {
                this.notificationDialog = val
            },
        }
    }
</script>